import { Row, Col } from "antd";

import Informations from "./informations";
const TabsContent = () => {
  return (
    <>
      <Row gutter={24}>
        <Col span={24}>
          <Informations />
        </Col>
      </Row>
    </>
  );
};

export default TabsContent;
